import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { HandlingUnitOverviewState } from './handling-unit-overview.state';
import { HandlingUnitOverview } from '../../models/handling-unit.model';
import {
  HandlingUnitOverviewInitialState,
  HandlingUnitOverviewLoad,
  HandlingUnitTrackingLoad,
} from './handling-unit-overview.actions';
import { HandlingUnitMaterialsFacade } from './handling-unit-materials/handling-unit-materials.facade';
import { Tracking } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class HandlingUnitOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(HandlingUnitOverviewState.getLoaded);
  overview$: Observable<HandlingUnitOverview> = this.store.select(HandlingUnitOverviewState.getOverview);
  tracking$: Observable<Tracking[]> = this.store.select(HandlingUnitOverviewState.getTracking);

  constructor(private store: Store, private handlingUnitMaterialsFacade: HandlingUnitMaterialsFacade) {}

  loadAll(itemNumbers: { deliveryNoteNumber: string; handlingUnitNumber: string }): void {
    const { deliveryNoteNumber, handlingUnitNumber } = itemNumbers;
    this.handlingUnitMaterialsFacade.handlingUnitNumber = handlingUnitNumber;
    this.handlingUnitMaterialsFacade.deliveryNoteNumber = deliveryNoteNumber;
    this.loadOverview(itemNumbers);
    this.loadTracking(itemNumbers);
    this.handlingUnitMaterialsFacade.loadAll();
  }

  setInitialState(): void {
    this.store.dispatch(new HandlingUnitOverviewInitialState());
  }

  private loadOverview(itemNumbers: { deliveryNoteNumber: string; handlingUnitNumber: string }): void {
    this.store.dispatch(new HandlingUnitOverviewLoad(itemNumbers));
  }

  private loadTracking(itemNumbers: { deliveryNoteNumber: string; handlingUnitNumber: string }): void {
    this.store.dispatch(new HandlingUnitTrackingLoad(itemNumbers));
  }
}
